import validate from "/usr/src/app/node_modules/.pnpm/nuxt@3.19.0_@emnapi+core@1.11.3_@emnapi+runtime@1.11.3_@parcel+watcher@2.5.1_@types+nod_8011865266390b0e4bb9267123272e5c/node_modules/nuxt/dist/pages/runtime/validate.js";
import city_45redirect_45global from "/usr/src/app/middleware/city-redirect.global.ts";
import clinic_45ref_45global from "/usr/src/app/middleware/clinic-ref.global.ts";
import doctor_45ref_45global from "/usr/src/app/middleware/doctor-ref.global.ts";
import personal_45profile_45load_45global from "/usr/src/app/middleware/personal-profile-load.global.ts";
import redirect_45from_45old_45path_45global from "/usr/src/app/middleware/redirect-from-old-path.global.ts";
import redirect_45slash_45global from "/usr/src/app/middleware/redirect-slash.global.ts";
import release_45features_45global from "/usr/src/app/middleware/release-features.global.ts";
import shop_45enabled_45global from "/usr/src/app/middleware/shop-enabled.global.ts";
import manifest_45route_45rule from "/usr/src/app/node_modules/.pnpm/nuxt@3.19.0_@emnapi+core@1.11.3_@emnapi+runtime@1.11.3_@parcel+watcher@2.5.1_@types+nod_8011865266390b0e4bb9267123272e5c/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  city_45redirect_45global,
  clinic_45ref_45global,
  doctor_45ref_45global,
  personal_45profile_45load_45global,
  redirect_45from_45old_45path_45global,
  redirect_45slash_45global,
  release_45features_45global,
  shop_45enabled_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/usr/src/app/middleware/auth.ts"),
  "clinic-access-control": () => import("/usr/src/app/middleware/clinic-access-control.ts"),
  "doctor-access-control": () => import("/usr/src/app/middleware/doctor-access-control.ts"),
  "shop-host-catalog": () => import("/usr/src/app/middleware/shop-host-catalog.ts"),
  "short-links": () => import("/usr/src/app/middleware/short-links.ts")
}